import React from 'react';

import { THEME_TYPE_DARK } from './constants';
import { ThemeTypes } from './types';

export default React.createContext<ThemeTypes>(THEME_TYPE_DARK);
